import {
  useCheckoutContext,
  useCreateBankTransferFromOrder,
  useCreatePartialBankTransferFromOrder,
} from '@ztechapps/order.webui'

export const useTemplateCreateBankTransfer = () => {
  const { createBankTransfer: createFullBankTransfer } = useCreateBankTransferFromOrder()
  const { createBankTransfer: createPartialBankTransfer } = useCreatePartialBankTransferFromOrder()

  const checkoutContext = useCheckoutContext()
  const orderDocument = checkoutContext.orderDocumentResult

  const hasPartialPayments = checkoutContext.hasPartialPayments

  const createBankTransfer = hasPartialPayments ? createPartialBankTransfer : createFullBankTransfer

  const payWithBank = async () => {
    if (orderDocument?.document?.paymentBalance?.balance <= 0) throw new Error('No balance to pay')
    const result = await createBankTransfer()
    return result.block
  }

  return { payWithBank }
}
